import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "name", "disabled", "min", "max"]

import {ref, watch} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
  id: {
    type: String,
    default: '',
  },

  name: {
    type: String,
    default: '',
  },

  value: {
    type: String,
    default: '',
  },

  modelValue: {
    type: String,
    default: '',
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  min: {
    type: [String, Number],
    default: '',
  },

  max: {
    type: [String, Number],
    default: '',
  },
},
  emits: ['update:modelValue', 'blur', 'focus'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props

const setDate = ref(props.modelValue);

watch(() => props.modelValue, (value) => {
  setDate.value = value;
});

watch(setDate, (newValue) => {
  emit('update:modelValue', newValue);
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    id: __props.id,
    type: "date",
    name: __props.name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((setDate).value = $event)),
    disabled: __props.disabled,
    min: __props.min,
    max: __props.max,
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur'))),
    onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus')))
  }, null, 40, _hoisted_1)), [
    [_vModelText, setDate.value]
  ])
}
}

})